<template>
    <div class="footer border-t py-12 sm:py-20">
        <div
            class="max-w-screen-xl w-full px-3 sm:px-5 mx-auto grid grid-rows-4 sm:grid-rows-1 grid-flow-row sm:grid-flow-col grid-cols-3 sm:grid-cols-12 gap-8 sm:gap-4"
        >
            <div
                class="row-span-2 sm:col-span-4 col-start-1 col-end-4 sm:col-end-5 flex flex-col md:items-start text-left"
            >
                <img src="/images/logo.svg" class="w-48 sm:w-60 mb-5" />
                <p class="mb-2 text-xs sm:text-base">
                    Un serviciu inteligent pentru organizarea si monitorizarea
                    invitatiilor.
                </p>

                <p class="text-gray-400 text-xs sm:text-sm">© {{ new Date().getFullYear() }} - InvitatiiSmart</p>
            </div>

            <div
                class="row-span-2 sm:col-span-2 sm:col-start-7 sm:col-end-9 flex flex-col text-left"
            >
                <p class="text-black-600 mb-4 font-medium text-base sm:text-lg">Servicii</p>

                <ul class="text-black-500 space-y-1 text-xs sm:text-sm">
                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/pachete"
                            >Pachete și prețuri</RouterLink
                        >
                    </li>

                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/howto">Cum funcționează</RouterLink>
                    </li>

                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/howto">Întrebări frecvente</RouterLink>
                    </li>
                </ul>
            </div>

            <div
                class="row-span-2 sm:col-span-2 sm:col-start-9 sm:col-end-11 flex flex-col text-left"
            >
                <p class="text-black-600 mb-4 font-medium text-base sm:text-lg">Companie</p>

                <ul class="text-black-500 space-y-1 text-xs sm:text-sm">
                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/about">Despre noi</RouterLink>
                    </li>

                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/contact">Contact</RouterLink>
                    </li>
                </ul>
            </div>

            <div
                class="row-span-2 sm:col-span-2 sm:col-start-11 sm:col-end-13 flex flex-col text-left"
            >
                <p class="text-black-600 mb-4 font-medium text-base sm:text-lg">Legal</p>

                <ul class="text-black-500 space-y-1 text-xs sm:text-sm">
                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/termsAndConditions"
                            >Termeni și condiții</RouterLink
                        >
                    </li>

                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/privacyPolicy"
                            >Politica de Confidențialitate</RouterLink
                        >
                    </li>

                    <li
                        class="hover:text-orange-500 cursor-pointer transition-all py-1"
                    >
                        <RouterLink to="/cookiePolicy"
                            >Politica de Cookies</RouterLink
                        >
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FooterComponent',
    props: {
        msg: String,
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss"></style>
